import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-ordered',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map